export default function createGalleryPager(galleryId, pageCount, currentPage) {
  const pager = $('<ul class="pagination"></ul>');
  const pagerItems = [];
  for (let i = 1; i <= pageCount; i += 1) {
    const pagerItem = $('<li class="page-item"></li>')
      .append(
        $('<a class="page-link"></a>')
          .attr('href', `#${galleryId}/${i}`)
          .text(i)
      );
    if (i === currentPage) {
      pagerItem.addClass('active');
    }
    pagerItems.push(pagerItem);
  }
  pager.append(pagerItems);
  return pager;
}
